export default __webpack_public_path__ + "img/icon-flag-en-us.asset.d7f309cf.jpg";